export default __webpack_public_path__ + "static/media/hero_dijkstra.696e1701.jpg";